// extracted by mini-css-extract-plugin
export default {"PaymentContainer":"PaymentModal_PaymentContainer__OWSBR"};